import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";

/**
 * Backwards-compat redirect from /shop?category=<Name> → /books/<slug>
 * If no category param, redirects to /books (all books).
 * Preserves other query params (q, sort, price, etc.)
 */
export default function LegacyShopRedirect() {
  const [params] = useSearchParams();
  const nav = useNavigate();

  useEffect(() => {
    const category = params.get("category");
    const featured = params.get("featured");

    // Build preserved params (drop category/featured — they map to path)
    const preserved = new URLSearchParams();
    for (const [k, v] of params.entries()) {
      if (k !== "category" && k !== "featured") preserved.set(k, v);
    }
    const qs = preserved.toString() ? `?${preserved.toString()}` : "";

    const run = async () => {
      if (category) {
        try {
          // Look up all categories and find best match by name
          const { data } = await api.get("/categories", { params: { active_only: true } });
          const match = data.find((c) => c.name.toLowerCase() === category.toLowerCase());
          if (match) {
            // Fetch full path
            const { data: full } = await api.get(`/categories/by-slug/${match.slug}`);
            const path = full.category.path || [match.slug];
            nav(`/books/${path.join("/")}${qs}`, { replace: true });
            return;
          }
        } catch (_) { /* fall through */ }
      }
      if (featured === "1" || featured === "true") {
        nav(`/books?featured=1${qs.replace(/^\?/, "&")}`, { replace: true });
        return;
      }
      nav(`/books${qs}`, { replace: true });
    };
    run();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-book py-24 text-center text-slate-400" data-testid="legacy-redirect">
      Redirecting…
    </div>
  );
}
